import {
	Button,
	Container,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableRow,
	Typography,
} from '@mui/material'
import SettingsIcon from '@mui/icons-material/Settings'
import _ from 'lodash'
import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RightBox } from '../../components'
import Modal from '../../components/Modal'
import { getEventEx } from '../../store/EventById/selectors'
import { updateOrCreateEventEx } from '../../store/HouseContainer/operations'
import { getActiveSubControl } from '../../store/SubControlById/selectors'
import {
	Control,
	House,
	initEventCo2,
	Scenario,
	TimePattern,
} from '../../types'
import EditCo2EventForm from './components/EditCo2EventForm'

type Props = {
	house: House
	scenario: Scenario
	control: Control
	timePattern: TimePattern
}

function Co2ManageTab({ scenario, control, timePattern }: Props) {
	const [open, setOpen] = React.useState(false)
	const dispatch = useDispatch()
	const activeSubc = useSelector((s) => getActiveSubControl(s, control))
	const eventEx = useSelector((s) =>
		getEventEx(s, scenario.eventIds, timePattern, activeSubc, initEventCo2),
	)
	const enableStyle = eventEx.enabled ? {} : { background: '#ddd' }

	return (
		<Container>
			<div style={{ marginTop: '8px' }}>
				<RightBox>
					<Button variant="outlined" onClick={() => setOpen(true)}>
						<SettingsIcon />
						編集{!eventEx.enabled && '・有効にする'}
					</Button>
				</RightBox>
				{!eventEx.enabled && <Typography>無効です</Typography>}
				<div style={{ ...enableStyle }}>
					<TableContainer component={Paper}>
						<Table style={{ ...enableStyle }}>
							<TableBody>
								<TableRow>
									<TableCell>CO2濃度(以下の場合オン)</TableCell>
									<TableCell>{eventEx.co2Above}ppm</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>窓が開いている場合はオフ</TableCell>
									<TableCell>{eventEx.windowCheck ? '有効' : '無効'}</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
				</div>
			</div>
			<Modal open={open} closeModal={() => setOpen(false)}>
				<EditCo2EventForm
					initialValues={_.omit(
						{
							...eventEx,
							scenarioId: scenario.id,
							timePattern,
							subControlId: activeSubc.id,
						},
						['id'],
					)}
					disabled={false}
					handleSubmit={(field) => {
						dispatch(updateOrCreateEventEx(field, eventEx.id))
						setOpen(false)
					}}
				/>
			</Modal>
		</Container>
	)
}

export default Co2ManageTab
